import { forwardRef } from 'react';

const Taskbar = forwardRef(function Taskbar(
  { isStartOpen, onToggleStart, openWindows, activeWindowId, apps, onToggleWindow, clock },
  ref
) {
  return (
    <footer className="taskbar panel-glass">
      <button
        type="button"
        className={`start-button ${isStartOpen ? 'is-open' : ''}`}
        onClick={onToggleStart}
        ref={ref}
        aria-label="Start"
      >
        Start
      </button>

      <div className="taskbar-apps" aria-label="Open apps in taskbar">
        {openWindows.map((windowId) => {
          const app = apps.find((item) => item.id === windowId);
          if (!app) return null;

          return (
            <button
              key={app.id}
              type="button"
              className={`taskbar-app ${activeWindowId === app.id ? 'is-active' : ''}`}
              onClick={() => onToggleWindow(app.id)}
            >
              {app.menuLabel}
            </button>
          );
        })}
      </div>

      <div className="taskbar-clock" aria-label="Current time">
        {clock}
      </div>
    </footer>
  );
});

export default Taskbar;
